export default __webpack_public_path__ + "static/media/immaginelore1.a4c2eb09.png";